// AuthContext.tsx
import React, { createContext, useEffect, useState, ReactNode } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { apiClient, ApiService } from "../service/ApiService";

type AuthContextType = {
  userToken: string | null;
  setUserToken: (token: string | null) => void;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextType>({
  userToken: null,
  setUserToken: () => {},
  logout: () => {},
});

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [userToken, setUserToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkToken = async () => {
      try {
        const token = await AsyncStorage.getItem("userToken");
        setUserToken(token);
        if (token) {
          apiClient.defaults.headers["Authorization"] = `Bearer ${token}`;
        } else {
          delete apiClient.defaults.headers["Authorization"];
        }
      } catch (error) {
        console.log("Failed to load token:", error);
      } finally {
        setIsLoading(false);
      }
    };

    checkToken();
  }, []);

  const logout = async () => {
    await AsyncStorage.clear()
    setUserToken(null);
    delete apiClient?.defaults.headers["Authorization"];

  };

  return (
    <AuthContext.Provider value={{ userToken, setUserToken, logout }}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};
